import { render } from "./TrxsContrato.vue?vue&type=template&id=4ba1b6bb&scoped=true"
import script from "./TrxsContrato.vue?vue&type=script&lang=js"
export * from "./TrxsContrato.vue?vue&type=script&lang=js"

import "./TrxsContrato.vue?vue&type=style&index=0&id=4ba1b6bb&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Public\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ba1b6bb"]])

export default __exports__